import React, { useState, useEffect } from 'react';

import s from "./Layout.module.css"
import SettingsContent from '../Settings/SettingsContent';
import { useIsMobile } from '../../hooks/mobileHook';
import SettingMenu from '../Settings/SettingsMenu';




export default function LayoutSettings() {
    const isMobile = useIsMobile();

    const [activeSideBar, setActiveSideBar] = useState(true)
    const [selectedMenu, setSelectedMenu] = useState('address');

    const handleMenuChange = (menu) => {
        setSelectedMenu(menu);
    };

    return (

        <div className={s.container}>
            {!isMobile ? (
                <>
                    {activeSideBar ? (
                        <SettingMenu onMenuChange={handleMenuChange} />
                    ) : (
                        <div onClick={() => setActiveSideBar(true)} className={s.showSidebarButton}>
                            <img src={'/showlogo.svg'}></img>
                        </div>
                    )}
                </>
            ) : (
                <></>
            )
            }
            <div className={s.content}>
                <SettingsContent selectedMenu={selectedMenu} handleMenuChange={handleMenuChange} />
            </div>
        </div>

    )
}